import { render, staticRenderFns } from "./WorkgateDialog.vue?vue&type=template&id=72f7083c&scoped=true"
import script from "./WorkgateDialog.vue?vue&type=script&lang=js"
export * from "./WorkgateDialog.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/components/workgate-dialog.scss?vue&type=style&index=0&id=72f7083c&prod&scoped=true&lang=scss&external"
import style1 from "@/assets/scss/pages/pages.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "@/assets/scss/pages/setting.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7083c",
  null
  
)

export default component.exports